import React, { useState, useEffect } from "react";
import styled from "styled-components";

import Holder from "./components/holder";
import Header from "./components/header";
import Footer from "./components/footer";

const Title = styled.div`
  font-family: "Basteleur";
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 125%;
  color: #ffffff;
  padding-top: 87px;
  padding-bottom: 16px;
`;

const Image = styled.img`
  margin: 0 auto;
  width: 100%;
`;

export default function Finish() {
  const [height, setHeight] = useState(window.innerHeight);
  function handleWindowSizeChange() {
    setHeight(window.innerHeight);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <>
      <Header inverted={true} />
      <Holder color={"#e96159"} height={height - 135}>
        <Title>Reserva cósmica concluída!</Title>
        <Image src="/images/finished.png" alt="Finished" />
      </Holder>
      <Footer inverted={true} />
    </>
  );
}
